
<Modal
  :modalType="modalType"
  mayCancel="true"
  v-on:cancel="onDone"
  width="auto"
  anchorStyle="topAuto"
  :anchorRect="anchorRect"
>
  <div
    class="Wrapper"
    v-for="colorSection in colorSections"
    :key="colorSection[0]"
  >
    <p v-if="colorSection[0]">{{ colorSection[0] }}:</p>
    <div class="ColorCollection">
      <div
        :class="getColorBoxCSSClass(color)"
        v-for="color in colorSection[1]"
        v-bind:key="color"
        v-bind:style="getStyle(color)"
        v-on:click="apply(color)"
      ></div>
    </div>
  </div>
</Modal>
